import { render, staticRenderFns } from "./SupportPromptTemplateForm.vue?vue&type=template&id=40044538&scoped=true"
import script from "./SupportPromptTemplateForm.vue?vue&type=script&lang=js"
export * from "./SupportPromptTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./SupportPromptTemplateForm.vue?vue&type=style&index=0&id=40044538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40044538",
  null
  
)

export default component.exports